


























import { Vue, Component, Watch } from 'vue-property-decorator';

import FilterPreview from '@/components/filter/FilterPreview.vue';
import FilterDropDown from '@/components/filter/FilterDropDown.vue';
import DoctorEntityModule from "@/store/doctors/entity";

import CalendarModule from '@/store/calendar';
import FilterModal from '@/store/modals/filter';
import { getById } from '@/api/crud';
import { Doctors } from '@/models/doctors';
import { EventBus } from '@/lib/EventBus';

@Component({
    name: 'CalendarFilter',
    components: {
        FilterPreview,
        FilterDropDown,
    }
})
export default class CalendarFilter extends Vue {
    focusKey = '' as string;

    get filterSettings() {
        return CalendarModule.filter.filterSettings;
    }

    get doctorFilterLoad() {
        return this.filterSettings.filterModel.doctor.load;
    }

    get specializationValue() {
        return this.filterSettings.filterModel.specialization.value;
    }

    get specializationCurrent() {
        return this.filterSettings.filterModel.specialization.current;
    }

    get isShow() {
        return FilterModal.modal.isShow;
    }

    get currentDoctorId() {
        if (this.filterSettings.filterModel.doctor.current) {
            return this.filterSettings.filterModel.doctor.current.id;
        }

        return 0;
    }

    get doctorQueryId() {
        return this.$route.query.doctor as string;
    }

    @Watch('specializationCurrent')
    async onSpecializationCurrentChange(specialization: { id: number; value: string }) {
        this.updateDoctorFilterString(specialization.id);

        if (specialization.id === 0) {
            CalendarModule.filter.resetSelect('doctor');

            await CalendarModule.filter.SET_FILTER('');
            await CalendarModule.filter.SET_FILTER_PREVIEW({});
            await CalendarModule.filter.SET_PAGE(1);

            return;
        }

        CalendarModule.filter.resetSelect('doctor');
        CalendarModule.filter.prepareFilterFromModal();
    }

    @Watch('specializationValue')
    onSpecializationValueChange(value: string) {
        if (!value) {
            this.resetDoctorFilterString();
        }
    }

    @Watch('doctorQueryId')
    onDoctorQueryIdChange(value: string) {
        this.updateDoctorFilter(value);
    }

    goToCalendar(doctorId: number | string) {
        if (String(this.currentDoctorId) === this.doctorQueryId) {
            return;
        }

        const routeParams: { name: string; query?: Record<string, string> } = { name: (this.$route.name as string) };

        if (+doctorId) {
            routeParams.query = { doctor: String(doctorId) };
        }
        
        this.$router.push(routeParams);
    }

    async updateDoctorFilter(doctorIdParam: string | number) {
        const current = {
            id: +doctorIdParam,
            value: '',
        }

        if (doctorIdParam) {
            const doctorFilter = this.filterSettings.filterModel.doctor;
            const doctor = await getById(Doctors.moduleName, String(doctorIdParam));
            DoctorEntityModule.SET_DOCTOR_DETAIL(doctor.doctor);
            
            const doctorName = [doctor.surname, doctor.name, doctor.patronymic].filter(name => name).join(' ');

            EventBus.$emit('calendar:clinics', doctor);

            current.value = doctorName;
            this.$store.dispatch(doctorFilter.action, { key: doctorFilter.key, value: doctorIdParam });
        }

        this.filterSettings.filterModel.doctor.current = current;
    }

    async created() {
        if (this.doctorQueryId) {
            await this.updateDoctorFilter(this.doctorQueryId);
        }

        await this.updateList();
    }
    
    async updateList() {
        CalendarModule.filter.updateFilter();
        const { doctorId } = CalendarModule;

        this.goToCalendar(doctorId);
        this.$emit('update:doctor', doctorId);
    }

    async resetFilters() {
        CalendarModule.clearSort();
        CalendarModule.filter.resetFilter();
     
        this.$emit('update:doctor', 0);
    }
    
    toggleFilter(_: any, key: string) {
        FilterModal.toggleModal();
        this.focusKey = key;
    }

    closeFilter() {
        FilterModal.closeModal();
    }

    updateDoctorFilterString(specializationId: number) {
        if (!this.doctorFilterLoad) {
            return;
        }

        let filterString = 'filters[0][id]=hasActualSchedule&filters[0][value]=1';

        if (specializationId) {
            filterString += `&filters[1][id]=specialization&filters[1][value]=${specializationId}`;
        }
        CalendarModule.filter.updateLoad({ key: 'doctor', value: { ...this.doctorFilterLoad, filterString } });
    }

    resetDoctorFilterString() {
        if (!this.doctorFilterLoad) {
            return;
        }

        CalendarModule.filter.updateLoad({ key: 'doctor', value: { ...this.doctorFilterLoad, filterString: '' } });
    }
}
